@import "../../themes/stories.globals";

:host {
  display: block;
}
